import { GRADES } from '../constants/grades';

// „vagyis” – adat → gyakorlati jelentés (haszon-fordítás), a strukturált
// mezőkből, sablonosan. Az elv: minden adat mellé egy őszinte, egymondatos
// fordítás, hogy MIT jelent a vevő mindennapjában. Ha egy adathoz nincs valós
// haszon, inkább nem írunk hozzá (null).
//
// FONTOS (márkahang + használt áru): csak IGAZ állítás. Nincs túlígérés –
// 80% alatt nyíltan megmondjuk, hogy napközben rátöltés kellhet. A túlígért
// leírás használt terméknél visszaküldésben és rossz értékelésben fizet vissza.

/** Akku-egészség (%) → gyakorlati jelentés. */
export const batteryBenefit = (battery) => {
  const n = parseInt(String(battery ?? ''), 10);
  if (!Number.isFinite(n)) return null;
  if (n >= 95) return 'vagyis gyakorlatilag gyári akku-egészség — egy töltés bőven kihúzza a napot.';
  if (n >= 90) return 'vagyis kényelmesen kitart egy teljes napot egy töltéssel.';
  if (n >= 80) return 'vagyis egy átlagos napra elég egy töltés.';
  return 'vagyis erős használatnál napközben érdemes rátölteni.';
};

/** Állapot-grade → jelentés. EGYETLEN FORRÁS: a `GRADES[..].definition`
 *  (constants/grades.js). Ugyanez a szöveg megy a listakártya és a modál
 *  badge-tooltipjébe és a termékoldalra – korábban itt egy második, eltérő
 *  megfogalmazás élt (a „Jó”-nál pl. kimaradt, hogy a kijelzőt nem érinti). */
export const gradeBenefit = (gradeKey) => GRADES[gradeKey]?.definition ?? null;

/** Tárhely (GB/TB a specifikációból) → gyakorlati jelentés. */
export const storageBenefit = (spec) => {
  const m = String(spec ?? '').match(/(\d+)\s*(tb|gb)/i);
  if (!m) return null;
  let gb = parseInt(m[1], 10);
  if (/tb/i.test(m[2])) gb *= 1024;
  if (!Number.isFinite(gb) || gb <= 0) return null;
  if (gb <= 32)  return 'vagyis a mindennapi appokra és pár száz fotóra elég.';
  if (gb <= 64)  return 'vagyis az appok és néhány ezer fotó kényelmesen elfér.';
  if (gb <= 128) return 'vagyis több ezer fotó, videó és az összes appod elfér.';
  return 'vagyis akkor sem fogysz ki a helyből, ha sokat fotózol és videózol.';
};
